var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11545_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 1.25C3.39793 0.885877 4.13436 0.625 5 0.625C5.86564 0.625 6.60207 0.885877 6.875 1.25",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37506 2.5H0.625",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.75L8.49759 6.8546C8.40046 8.04931 8.3519 8.64666 7.8772 9.01083C7.4025 9.375 6.6724 9.375 5.2122 9.375H4.7878C3.3276 9.375 2.5975 9.375 2.1228 9.01083C1.6481 8.64666 1.59954 8.04931 1.50241 6.8546L1.25 3.75",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49268 4.7699L3.73165 7.07253",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50728 4.7699L6.26831 7.07253",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11545_428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.87621c25a04fa564d0d9bf555321ec77.svg";